/**
 * @ignore
 * @param {String} value Numeric value
 * @return {String}
 */
function enforceLeadingZero(value) {
    return value < 10 ? '0' + value : value;
}

/**
 * Convert a distance in meters to yards.
 * @param {Number} distanceMeters
 * @return {Number}
 */
function convertMetersToYards(distanceMeters) {
    return 1.0936133 * distanceMeters;
}

/**
 * @ignore
 * @param {Number} distanceMeters
 * @return {Number}
 */
function convertMetricToMiles(distanceMeters) {
    return 0.000621371192 * distanceMeters;
}

/**
 * @ignore
 * @param {Number} distanceMeters
 * @return {String} Distance in miles or yards.
 */
function formatMetricAsImperialDistance(distanceMeters) {
    const yards = convertMetersToYards(distanceMeters),
        miles = convertMetricToMiles(distanceMeters);
    return miles < 1 ? Math.round(yards) + ' yd' : Math.round(miles * 10) / 10 + ' mi';
}

/**
 * @ignore
 * @param {Number} distanceMeters
 * @return {String} Distance in kilometers or meters.
 */
function formatAsMetricDistance(distanceMeters) {
    const distance = Math.round(distanceMeters);
    if (distance >= 1000) {
        return Math.round(distance / 100) / 10 + ' km';
    }
    return distance + ' m';
}

class UnitFormatConverter {
    /**
    * Convert a distance in yards to meters.
    * @param {Number} distanceYards Distance in yards.
    * @return {Number}
    */
    convertYardsToMeters(distanceYards) {
        return Math.round(distanceYards / 1.0936133);
    }

    convertMetersToYards(distanceMeters) {
        return convertMetersToYards(distanceMeters);
    }

    /**
     * Converts the given time in seconds to a string with the the format of 'HH h MM min' or 'MM min SS s'.
     *
     * HH - hours MM - minutes SS - seconds.
     *
     * @param {Number} [seconds] Number of seconds.
     * @return {String|undefined} Formatted time.
     *
     * @example
     * ```javascript
     * tomtom.unitFormatConverter.formatTime(3600);  / returns 1 h 0 min
     * ```
     */
    formatTime(seconds) {
        let secondsNum, minutes;
        if (seconds === undefined) {
            return undefined;
        }
        secondsNum = parseInt(seconds, 10);
        const hours = Math.floor(secondsNum / 3600);
        minutes = Math.floor((secondsNum - hours * 3600) / 60);
        if (secondsNum < 60) {
            return secondsNum + ' s';
        }
        secondsNum %= 60;
        const secondsFormatted = enforceLeadingZero(secondsNum);
        minutes %= 60;
        const minutesFormatted = enforceLeadingZero(minutes);
        if (hours > 0) {
            return hours + ':' + minutesFormatted + ' h';
        }
        return minutes + ':' + secondsFormatted + ' min';
    }

    /**
     * Converts a date in the machine format to a more human readable form.
     *
     * Returns a formatted string created from the given date in UTC format.
     *
     * @param {String} [dateInMs] Date and time specified in the RFC-3339 format with an optional time zone offset.
     * @return {String} Formatted time in hours and minutes.
     *
     * @example
     * ```javascript
     * tomtom.unitFormatConverter.formatHourAndMinute('2016-03-01T15:45:58+01:00') // gives '3:45'
     * ```
     */
    formatHourAndMinute(dateInMs) {
        const date = new Date(dateInMs);
        const hour = date.getHours(),
            minute = date.getMinutes();
        return enforceLeadingZero(hour) + ':' + enforceLeadingZero(minute);
    }

    /**
     * Converts distance in meters to a proper display format in SI or imperial units.
     *
     * @param {Number} distanceMeters Distance in meters.
     * @param {Boolean} [imperial=false] Use imperial units.
     * @return {String} Aformatted distance.
     */
    formatDistance(distanceMeters, imperial) {
        if (distanceMeters === undefined) {
            return undefined;
        }
        if (imperial) {
            return formatMetricAsImperialDistance(distanceMeters);
        }
        return formatAsMetricDistance(distanceMeters);
    }
}

export default new UnitFormatConverter();



// WEBPACK FOOTER //
// ./services/unitFormatConverter/unitFormatConverter.js